// extracted by mini-css-extract-plugin
export var section = "large-link-module--section--Q4ll7";
export var link = "large-link-module--link--VkPXk";
export var content = "large-link-module--content--K3yqw";
export var arrow = "large-link-module--arrow--lla17";
export var arrowBGwhite = "large-link-module--arrowBGwhite--LbceM";